exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".AlertBox {\n  background: #d4edda;\n  /*border-left: 8px solid #155724;*/\n  border-left: 8px solid #155724;\n  /*color: ##155724;*/\n  color: #155724;\n  line-height: 1.6;\n  margin-bottom: 40px;\n  margin-top: 24px;\n  padding: 8px 12px; }\n\n.AlertBox a {\n  /*color: #155724;*/\n  color: #155724;\n  text-decoration: underline; }\n\n.AlertBox a:hover {\n  color: #000;\n  -webkit-text-decoration-color: #155724;\n  text-decoration-color: #155724; }\n\n.AlertBox[data-type=\"error\"] {\n  background: #f8d7da;\n  border-color: #721c24;\n  color: #721c24; }\n\n.AlertBox[data-type=\"error\"] a {\n  color: #721c24; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/AlertBox/AlertBox.scss
// module id = 1571
// module chunks = 0